var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDonation = function SvgDonation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8216 60.4767C48.3961 60.1776 49.0797 60.1753 49.6562 60.4703L76.5213 74.2196C77.973 74.9626 77.973 77.0374 76.5213 77.7804L49.6562 91.5297C49.0797 91.8247 48.3961 91.8224 47.8216 91.5233L21.4081 77.774C19.9727 77.0269 19.9727 74.9731 21.4081 74.226L47.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1769 13.1547C46.4145 12.4402 47.9393 12.4402 49.1769 13.1547L76.3538 28.8453C77.5914 29.5598 78.3538 30.8803 78.3538 32.3094V63.6906C78.3538 65.1197 77.5914 66.4402 76.3538 67.1547L49.1769 82.8453C47.9393 83.5598 46.4145 83.5598 45.1769 82.8453L18.0008 67.1547C16.7633 66.4402 16.0009 65.1197 16.0008 63.6907L16.0001 32.3095C16 30.8804 16.7624 29.5598 18.0001 28.8453L45.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 47.2139 12)",
    fill: "url(#paint0_linear_10345_110350)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 47.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 47.2139 48)",
    fill: "url(#paint1_linear_10345_110350)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 47.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6746 46.68C71.3414 46.0876 70.8608 45.6859 70.2712 45.5071C69.6816 45.3283 68.9995 45.3774 68.2798 45.6504C67.56 45.9234 66.8227 46.4128 66.127 47.0792C65.4313 47.7456 64.7967 48.5704 64.274 49.4874L63.669 50.506L63.0831 50.199C62.5617 49.8729 61.9241 49.7734 61.2232 49.9089C60.5223 50.0444 59.7784 50.4109 59.0534 50.978C58.3326 51.5301 57.6489 52.2668 57.0593 53.1269C56.4697 53.987 55.9912 54.9456 55.6634 55.9232C55.2253 57.2146 55.0722 58.4833 55.2263 59.5452C55.3805 60.607 55.8339 61.4067 56.5206 61.8283L63.161 66.2685C63.2271 66.3125 63.306 66.3322 63.3933 66.3264C63.4805 66.3206 63.5743 66.2894 63.669 66.2347C63.7637 66.1801 63.8575 66.103 63.9447 66.008C64.032 65.913 64.1109 65.8022 64.177 65.6819L70.8082 53.5948C71.4978 52.3778 71.9536 51.0512 72.1094 49.8078C72.2652 48.5643 72.1129 47.4686 71.6746 46.68V46.68Z",
    fill: "url(#paint2_linear_10345_110350)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.104 49.978L63.6708 52.3907L62.2494 51.6461L62.2314 51.6348C61.8401 51.39 61.3659 51.318 60.8506 51.4176C60.3355 51.5172 59.7906 51.786 59.2596 52.2013L59.2437 52.2137C58.7172 52.6169 58.2137 53.158 57.7757 53.797C57.3374 54.4364 56.9766 55.1564 56.7277 55.8987L56.7248 55.9074C56.393 56.8855 56.2754 57.8525 56.3931 58.6632C56.5107 59.4736 56.8557 60.0753 57.3683 60.39L57.3776 60.3956L63.6691 64.6025L69.952 53.1503L69.9618 53.133C70.4768 52.2241 70.8239 51.2209 70.9429 50.2711C71.0618 49.322 70.9451 48.4881 70.6136 47.8905C70.3594 47.4393 69.9955 47.138 69.5552 47.0044C69.1147 46.8708 68.6092 46.9086 68.0803 47.1092C67.5514 47.3099 67.0095 47.6693 66.4965 48.1606C65.9833 48.6522 65.5101 49.2655 65.1169 49.9554L65.104 49.978ZM71.6746 46.68C71.3414 46.0876 70.8608 45.6859 70.2712 45.5071C69.6816 45.3283 68.9995 45.3774 68.2798 45.6504C67.56 45.9234 66.8227 46.4128 66.127 47.0792C65.4313 47.7456 64.7967 48.5704 64.274 49.4874L63.669 50.506L63.0831 50.199C62.5617 49.8729 61.9241 49.7734 61.2232 49.9089C60.5223 50.0444 59.7784 50.4109 59.0534 50.978C58.3326 51.5301 57.6489 52.2668 57.0593 53.1269C56.4697 53.987 55.9912 54.9456 55.6634 55.9232C55.2253 57.2146 55.0722 58.4833 55.2263 59.5452C55.3805 60.607 55.8339 61.4067 56.5206 61.8283L63.161 66.2685C63.2271 66.3125 63.306 66.3322 63.3933 66.3264C63.4805 66.3206 63.5743 66.2894 63.669 66.2347C63.7637 66.1801 63.8575 66.103 63.9447 66.008C64.032 65.913 64.1109 65.8022 64.177 65.6819L70.8082 53.5948C71.4978 52.3778 71.9536 51.0512 72.1094 49.8078C72.2652 48.5643 72.1129 47.4686 71.6746 46.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 16.0381 30)",
    fill: "url(#paint3_linear_10345_110350)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 16.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6769 14.0207L75.8538 29.7113C76.782 30.2472 77.3538 31.2376 77.3538 32.3094V63.6906C77.3538 64.7624 76.782 65.7528 75.8538 66.2887L48.6769 81.9793C47.7487 82.5152 46.6051 82.5152 45.6769 81.9792L18.5008 66.2887C17.5727 65.7528 17.0009 64.7624 17.0008 63.6907L17.0001 32.3094C17 31.2376 17.5718 30.2472 18.5001 29.7113L45.6769 14.0207C46.6051 13.4848 47.7487 13.4848 48.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110350",
    x: 4.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.729412 0 0 0 0 0.109804 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110350",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110350",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB61B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110350",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB206"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110350",
    x1: 72.1688,
    y1: 61.3224,
    x2: 55.6194,
    y2: 52.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10345_110350",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB105"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDonation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "donation.c550874f1bceeac1499940248c5ee95b.svg";